import styled from "styled-components";

export const Container = styled.div`
    width: 100%;
    height: 100vh;
    background-color: ${(props) => props.theme.colors.roxoBy};
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    `

export const Form = styled.form`

    background-color: #212529;
    border-radius: 10px;
    padding: 24px;
    box-shadow: 0px 0px 10px #000;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 30vw;

    h1 {
        color: #ffffff;
        font-size: 42px;

    }

    @media (max-width: 768px) {
        width: 90vw;
    }


    `

export const TitleContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: 500px;
    align-items: center;
    justify-content: center;
    margin-bottom: 20px;
    text-align: center;

    h1 {
        color: #ffffff;
        font-size: 42px;
        text-align: center;
        margin-bottom: 12px;
    }

    h2 {
        color: #ffffff;
        font-size: 24px;

    }

    h3 {
        color: #ffffff;
        font-size: 18px;
        margin-bottom: 20px;
        text-align: center;
    }

    p {
        color: #ffffff;
        font-size: 16px;
        margin-bottom: 20px;
        text-align: center;
    }
    
    `

export const Input = styled.input`
    width: 100%;
    height: 36px;
    background-color: #f5f5f5;
    border: 1px solid #ccc;
    border-radius: 5px;
    padding: 12px;
    position: relative;
    &[type="number"]::-webkit-inner-spin-button,
    &[type="number"]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

    &[type="number"] {
        -moz-appearance: textfield;
    }

    &:disabled {
        cursor: not-allowed;
    }
    `

export const Button = styled.button`
    

    background-color: ${(props) => props.theme.colors.roxoBy};
    border: 0;
    border-radius: 5px;
    color: #ffffff;
    font-weight: bold;
    margin-top: 10px;
    cursor: pointer;
    transition: 0.3s;
    text-align: center;
    align-self: end;

    padding: 10px 10px;

    &:hover {
        background-color: ${(props) => props.theme.colors.roxoBy};
        color: #ffffff;
        opacity: 0.8;
    }
    `

export const Select = styled.select`
    width: 100%;
    height: 40px;
    background-color: #f5f5f5;
    border: 1px solid #ccc;
    border-radius: 5px;
    padding: 0 15px;
    margin-top: 10px;
    `

export const InputContainer = styled.div`
  position: relative;
  width: 100%;
  margin-top: 6px;
  label {
    color: #fff;
    font-size: 12px;
    transition: 0.3s;
    font-weight: bold;  
  }
  
  input {
    width: 100%;
    height: 24px;
    background-color: #f5f5f5;
    border: 1px solid #ccc;
    border-radius: 5px;
    padding: 16px;
    position: relative;
    margin-top: 4px;
    margin-bottom: 4px;
    
    }

  input:disabled {
    cursor: not-allowed;
  }

  input:disabled:hover {
    background-color: #f5f5f5;
    color: #000000;
    opacity: 0.8;
  }

  input:disabled:hover + span {
    visibility: visible;
    opacity: 1;
  }
`;

export const Tooltip = styled.span`
  content: "";
  position: absolute;
  top: 20px;
  left: 100%;
  transform: translateX(-50%);
  background-color: #000000;
  color: #ffffff;
  padding: 5px;
  border-radius: 5px;
  font-size: 12px;
  opacity: 0;
  transition: 0.3s;
  visibility: hidden;
  white-space: nowrap;
`;